const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/chatbot';

export async function logInteraction(payload: any) {
  const res = await fetch(`${API_BASE_URL}/logs`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function getKB() {
  const res = await fetch(`${API_BASE_URL}/kb`);
  return res.json();
}

export async function addKB(chunk: any) {
  const res = await fetch(`${API_BASE_URL}/kb`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(chunk),
  });
  return res.json();
}

export async function getAnalytics() {
  const res = await fetch(`${API_BASE_URL}/analytics`);
  return res.json();
}

export async function getLogs() {
  const res = await fetch(`${API_BASE_URL}/logs`);
  return res.json();
}
